import { render } from "./DesktopTable.vue?vue&type=template&id=1e57e96a&scoped=true"
import script from "./DesktopTable.vue?vue&type=script&lang=js"
export * from "./DesktopTable.vue?vue&type=script&lang=js"

import "./DesktopTable.vue?vue&type=style&index=0&id=1e57e96a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e57e96a"

export default script